export * from './lib/variable-selector.module';
